import { FaExchangeAlt } from 'react-icons/fa';
import { ReceivableItem, InstallmentItem } from '../types/operations';

interface Props {
    receivables: ReceivableItem[];
    onConvert: (installments: InstallmentItem[]) => void;
    disabled?: boolean;
}

const ConvertReceivablesToInstallment: React.FC<Props> = ({ receivables, onConvert, disabled }) => {
    const handleConvert = () => {
        if (!receivables.length) return;

        const installments: InstallmentItem[] = [...receivables]
            .sort((a, b) => {
                const [dA, mA, yA] = (a.receivable_due_date || '').split('/');
                const [dB, mB, yB] = (b.receivable_due_date || '').split('/');
                return new Date(+yA, +mA - 1, +dA).getTime() - new Date(+yB, +mB - 1, +dB).getTime();
            })
            .map((item, index) => ({
                number: index + 1,
                value: item.receivable_amount || 0,
                dueDate: item.receivable_due_date || '',
                format: 'VALOR',
            }));

        onConvert(installments);
    };

    return (
        <button
            type="button"
            className="inline-flex items-center gap-2 px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-gray-500 dark:hover:bg-gray-600"
            onClick={handleConvert}
            disabled={disabled || !receivables.length}
            title="Converter recebíveis em parcelas"
        >
            <FaExchangeAlt className="h-4 w-4" />
            Gerar parcelas pelos recebíveis
        </button>
    );
};

export default ConvertReceivablesToInstallment;
